import { isString } from "lodash";

/**
 * Removes 'px' suffix from a string value
 * @param value - The string value that may contain 'px' suffix
 * @returns The string with 'px' removed, or the original value if no 'px' found
 */
export const stripPx = <T>(value: T): T => {
  if (!isString(value)) return value;
  return value.replace("px", "") as T;
};
